import http from '@/http'
const URL = '/admin/wa/messenger'

export const listConversations = async (params) => {
  return http.get(URL + '/conversations', { params })
}

export const showConversation = async (id) => {
  return http.get(URL + `/conversations/${id}`)
}

export const getMessages = async (id, params) => {
  return http.get(URL + `/conversations/${id}/messages`, { params })
}

export const sendMessage = (id, payload) => {
  return http.post(URL + `/conversations/${id}/messages`, payload)
}

export const sendMessageFormData = (id, formData) => {
  return http.post(URL + `/conversations/${id}/messages`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export const sendMedia = (id, formData) => {
  return http.post(URL + `/conversations/${id}/messages/media`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export const startConversation = (payload) => {
  return http.post(URL + '/conversations/start', payload)
}

export const startConversationFormData = (formData) => {
  return http.post(URL + '/conversations/start', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export const markAsRead = (id) => {
  return http.patch(URL + `/conversations/${id}/read`)
}

export const closeConversation = (id) => {
  return http.patch(URL + `/conversations/${id}/close`)
}

export const archiveConversation = (id) => {
  return http.patch(URL + `/conversations/${id}/archive`)
}

export const unarchiveConversation = (id) => {
  return http.patch(URL + `/conversations/${id}/unarchive`)
}

export const reopenConversation = (id) => {
  return http.patch(URL + `/conversations/${id}/reopen`)
}

export const completeConversation = (id) => {
  return http.patch(URL + `/conversations/${id}/complete`)
}

export const assignConversation = (id, adminId) => {
  return http.patch(URL + `/conversations/${id}/assign`, { assigned_admin_id: adminId })
}

export const getTemplates = async (params) => {
  return http.get(URL + '/templates', { params })
}

export const getOperators = async () => {
  return http.get(URL + '/operators')
}

export const searchParticipants = async (params) => {
  return http.get('/admin/participants', { params })
}

export default {
  listConversations,
  showConversation,
  getMessages,
  sendMessage,
  sendMessageFormData,
  sendMedia,
  startConversation,
  startConversationFormData,
  markAsRead,
  closeConversation,
  archiveConversation,
  unarchiveConversation,
  reopenConversation,
  completeConversation,
  assignConversation,
  getTemplates,
  getOperators,
  searchParticipants
}
